import PolicyDocuments from './components/PolicyDocuments.vue';
import NoticesAndConfirmations from './components/NoticesAndConfirmations.vue';
import InvestmentStatements from './components/InvestmentStatements.vue';
import DocumentList from './DocumentList.vue';
import DocumentsPage from './DocumentsPage.vue';
import DashboardLayout from '@/layouts/DashboardLayout.vue';
import { RouteNames } from '@/router/routeNames';

export default {
  path: '/documents',
  component: DashboardLayout,
  children: [
    {
      name: RouteNames.DOCUMENT_LIST_MOBILE,
      path: 'document-list/:routeName',
      component: DocumentList,
      props: true,
    },
    {
      name: RouteNames.DOCUMENTS,
      path: '',
      component: DocumentsPage,
      children: [
        {
          name: RouteNames.POLICY_DOCUMENTS,
          path: 'policy-documents',
          component: PolicyDocuments,
        },
        {
          name: RouteNames.NOTICES_AND_CONFIRMATIONS,
          path: 'notices-and-confirmations',
          component: NoticesAndConfirmations,
        },
        {
          name: RouteNames.INVESTMENT_STATEMENTS,
          path: 'investment-statements',
          component: InvestmentStatements,
        },
      ],
    },
  ],
};
